import { render, staticRenderFns } from "./AnalitRubricators.vue?vue&type=template&id=4ce143e1&scoped=true"
import script from "./AnalitRubricators.vue?vue&type=script&lang=js"
export * from "./AnalitRubricators.vue?vue&type=script&lang=js"
import style0 from "./AnalitRubricators.vue?vue&type=style&index=0&id=4ce143e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce143e1",
  null
  
)

export default component.exports